/**
 * 判断是否单选,取context中与props中的值做判断
 * 1.所有tab全局单选
 * todo 2.后期可能针对单个tab做单选,从props中传入
 * todo 3.命中一个则为单选模式
 * @param context
 * @returns {*}
 */
function singleMode({ context = {} }) {
	const { globalSingleSelect } = context;
	return !!globalSingleSelect;
}
export default singleMode;
